import { Controller } from "@hotwired/stimulus";

// Previews a newly chosen POS product/brand image before the form is saved: swaps the picked file into
// the preview <img> and hides the empty state. The upload itself still happens on form submit (Nexus
// scales and stores it); this is purely the local preview.
export default class extends Controller {
  static targets = ["input", "image", "placeholder"];

  connect() {
    // The server-rendered image, so a cleared pick falls back to it rather than to the empty state.
    this.originalSrc = this.imageTarget.getAttribute("src");
  }

  preview() {
    const file = this.inputTarget.files[0];
    if (!file) return;

    // Release any object URL from a previous pick before creating a new one.
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
    this.objectUrl = URL.createObjectURL(file);

    this.imageTarget.src = this.objectUrl;
    this.imageTarget.classList.remove("hidden");
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden");
  }

  // Drop a picked file's preview and show the server image again (or the empty state when there is
  // none) — used when a brand override row is removed, so a re-added row shows what the save keeps.
  reset() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
    const hasImage = Boolean(this.originalSrc);
    if (hasImage) {
      this.imageTarget.src = this.originalSrc;
    } else {
      this.imageTarget.removeAttribute("src");
    }
    this.imageTarget.classList.toggle("hidden", !hasImage);
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.toggle("hidden", hasImage);
  }

  disconnect() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
  }
}
